import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import { Suspense } from "react";
import HeroSection from "./components/sections/HeroSection";
import About from "./components/sections/About";
import Services from "./components/sections/Services";
import Faq from "./components/sections/Faq";
import Testimon from "./components/sections/Testimon";
import Contact from "./components/sections/Contact";
import Footer from "./components/sections/Footer";
import PageNotFound from "./components/pages/PageNotFound";
import CarTypes from "./components/sections/CarTypes";
import Packages from "./components/sections/Packages";
import AdminLogin from "./components/superbase/AdminLogin";
import PrivateRoute from "./components/superbase/PrivateRoute";
import AdminForms from "./components/superbase/AdminForms";
import TermsConditions from "./components/pages/TermsConditions";
import Privacy from "./components/pages/Privacy";
import WhatsAppButton from "./components/sections/WhatsAppButton";
import ScrollToTop from "./components/sections/ScrollToTop";
import AboutUs from "./components/pages/AboutUs";
//- prices section import Pricing from "./components/sections/Pricing";

const Loader = () => (
  <div className="w-full h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-300 border-t-black"></div>
  </div>
);

function App() {
  const location = useLocation();
  const hideOnPages = ["/admin-login", "/dashboard"];
  const shouldHide = hideOnPages.includes(location.pathname);
  return (
    <div className="App font-montserrat">
      <ScrollToTop />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <HeroSection />
                <About />
                <Services />
                <Packages />
                <CarTypes />
                {/* <Pricing /> */}
                <Faq />
                <Testimon />
                <Contact />
                <Footer />
              </>
            }
          />

          <Route path="/admin-login" element={<AdminLogin />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <AdminForms />
              </PrivateRoute>
            }
          />
          <Route path="/terms&conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/about_us" element={<AboutUs />} />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>

      {/* <header className="App-header">
        <h1 className="text-4xl text-center text-red-600">Cargen project</h1>
      </header> */}
      {!shouldHide && <WhatsAppButton />}
    </div>
  );
}

export default App;
